import { useState, useEffect } from "react";
import { makeStyles } from "@mui/styles";
import FlatIconButton from "./FlatButton";

const registerBtn = {
  fontSize: "0.875rem",
  border: "2px solid white",
  filter: "drop-shadow(0px 4px 4px rgba(130, 130, 130, 0.25))",
};

const useStyles = makeStyles((theme) => ({
  title: {
    fontSize: "3rem",
    lineHeight: "58.09px",
    [theme.breakpoints.down("md")]: {
      textAlign: "center",
      width: "100%",
    },
  },
  subtitle: {
    fontSize: "3rem",
    lineHeight: "44px",
    fontWeight: 500,
    textAlign: "center",
    [theme.breakpoints.down("md")]: {
      width: "100%",
    },
  },
  passwordContainer: {
    border: "2px solid #F2F2F2",
    height: "79px",
    width: "374px",
    borderRadius: "15px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginTop: "30px",
    [theme.breakpoints.down("sm")]:{
      width: "270px"
    },
    [theme.breakpoints.down("md")]:{
      border: "2px solid #D9D9D9",
    }
  },
  textContainer: {
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
  },
  formStyles: {
    marginTop: 40,
    width: "100%",
    maxWidth: "780px",
    maxHeight: 945,
    minHeight: 800,
    margin: "auto",
    position: "relative",
    padding: "20px 20px 90px",
    background: "white",
    borderRadius: 10,
    height: "auto",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    flexDirection: "column",
    gap: 15,
    [theme.breakpoints.up("md")]: {
      borderRadius: "8px",
      padding: "80px 94px 30px",
    },
    [theme.breakpoints.down("sm")]:{
      padding: "25px 10px 90px",
      minHeight: "500px",
    },
    [theme.breakpoints.down("md")]:{
      background: "none"
    }
  },
  btnContainer: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
    gap: 25,
    [theme.breakpoints.up("md")]: {
      gridColumn: "1/-1",
    },
  },
  
}));

export default function ModalPassword({passwordSubmit, tempPw}) {
  const classes = useStyles();
  const [sending, setSending] = useState(false);
  const [pw, setPw] = useState("");

  useEffect(() => {
    setPw(tempPw);
  }, [tempPw]);

  const handleSubmit =  async (e) => {
    e.preventDefault();
    passwordSubmit();
  }

  return (
      <form className={classes.formStyles}>
        <div className={classes.textContainer}>
          <h4 className={classes.title}>Contraseña</h4>
          <div className={classes.passwordContainer}>
            <p className={classes.subtitle}>{pw}</p>
          </div>
        </div>
        <div className={classes.btnContainer}>
          <FlatIconButton
            isDisable={sending}
            widthBtn="290px"
            typeButton="submit"
            title={sending ? "Enviando..." : "Registrar"}
            onClick={handleSubmit}
            customStyles={registerBtn}
          />
        </div>
      </form>
  );
}